import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import Location from "../../utilities/data/model/Location";
import { useTranslation } from "../../utilities/i18n";

export type SelectLocationModalScreenProps = StackScreenProps<
  any,
  "SelectLocationModalScreen"
>;

export const SelectLocationModalScreen = ({
  navigation,
}: SelectLocationModalScreenProps) => {
  const { t } = useTranslation("common");
  const database = useDatabase();
  const [locations, setLocations] = React.useState<Location[] | undefined>();
  const { watch, setValue } = useFormContext<{
    locationId: string;
  }>();
  const { colors } = useThemeProvider();

  const watchedLocationId = watch("locationId");

  React.useEffect(() => {
    database
      .get<Location>("locations")
      .query()
      .fetch()
      .then((l) => setLocations(l));
  }, []);

  const handleOnSelect = React.useCallback((locationId: string) => {
    setValue("locationId", locationId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  const items: FlatActionListItem[] = React.useMemo(() => {
    return (
      locations?.map((location) => {
        return {
          key: location.id,
          title: location.name,
          onPress: () => handleOnSelect(location.id),
          componentRight: (icon) => {
            return watchedLocationId == location.id ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [locations, watchedLocationId, handleOnSelect]);

  return (
    <Page title={t("modal_select_location_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
